/** Minimal shape both combobox halves share — the filter only ever reads the option's value. */
type FilterableOption = { value: string };

type ComboboxFilter = (itemValue: string, query: string) => boolean;

/**
 * Adapts a `(itemValue, query)` filter to what base-ui hands the root's `filter` prop.
 *
 * `null` disables filtering entirely, for a combobox whose `options` are ALREADY the result of a server-side
 * search — filtering them again in the browser can only hide rows the server decided to return. `undefined`
 * keeps base-ui's default substring match over the label.
 *
 * Base-ui passes the full option object at runtime while typing the parameter as `Value`, so the parameter is
 * declared as `string` to keep `Value` inferred from `value`/`onValueChange` rather than widening it to the
 * option type. The cast inside only reads `.value`, always present on an option.
 */
export function buildComboboxFilter(customFilter?: ComboboxFilter | null): ComboboxFilter | null | undefined {
  if (customFilter === null) return null;
  if (!customFilter) return undefined;
  return (item: string, query: string) => customFilter((item as unknown as FilterableOption).value, query);
}
